import React, { useContext, useEffect } from 'react'
import { Route, Redirect, useHistory } from 'react-router-dom'
import { AuthContext } from './auth'
import { Header, Footer } from '../pages/common'
import { initializeGA } from '../lib/ga'

const signInPathName = '/auth/signin'

export default ({ children, ...rest }: any) => {
  const { listen } = useHistory()
  useEffect(() => {
    if (process.env.REACT_APP_GA_TRACKING_ID) {
      initializeGA(process.env.REACT_APP_GA_TRACKING_ID);
    }
    const unlisten = listen((location) => {
      if (!(window as any).gtag) return
      if (!process.env.GA_TRACKING_ID) {
        console.log(
          'Tracking not enabled, as `trackingId` was not given and there is no `GA_MEASUREMENT_ID`.'
        )
        return
      }
      (window as any).gtag('config', process.env.GA_TRACKING_ID, { page_path: location.pathname })
    })
    return unlisten
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let route = <Route {...rest} />

  if (rest.index) {
    route = (<React.Fragment>
      <div id="index">
        {route}
      </div>
    </React.Fragment>)
  }

  if (rest.contents) {
    route = (<React.Fragment>
      <div id="contents">
        {route}
      </div>
    </React.Fragment>)
  }

  // wrap
  route = (<React.Fragment>
    {(rest.wrap || rest.header) && <Header {...rest} />}
    {route}
    {(rest.wrap || rest.footer) && <Footer {...rest} />}
  </React.Fragment>)

  if (rest.id) {
    route = <div id={rest.id}>{route}</div>
  }

  // authenticate
  if (rest.auth) {
    route = <AuthRoute {...rest}>{route}</AuthRoute>
  }

  return route
}

const AuthRoute = ({ children, ...rest }: any) => {
  const auth = useContext(AuthContext)
  delete rest.component

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: signInPathName,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}